import React, { useCallback, useEffect, useState } from 'react';
import { Table, Spinner } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import DateAsLocaleString from '../../Utilities/DateAsLocaleString';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const GetRecentlyReceivedRecipes = () => {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [files, setFiles] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const [variant, setVariant] = useState<"warning" | "danger" | "">("");

    const getSpecFiles = useCallback(async () => {
        setLoading(true);
        await fetchDataAuthenticated("api/v1/admin/specImports/received", "GET")
            .then(response => {
                if (response.status === 403) {
                    return Promise.reject({ title: "Unauthorised", detail: "Unable to fetch recent spec imports due to being unauthorised. Admin privilege required" });
                }
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setError("");
                setFiles(data);
                if (data.length === 0) {
                    setVariant("warning");
                }
                else {
                    setVariant("");
                }
            })
            .catch(error => {
                setFiles([]);
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setError(error.detail);
            })
            .finally(() => setLoading(false));
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getSpecFiles();
    }, [getSpecFiles]);

    function SpecFilesTable() {
        if (loading) {
            return (<Spinner />);
        }
        if (error) {
            return (<div>{error}</div>);
        }

        if (files.length === 0) {
            return (<div>No Files</div>);
        }

        return (
            <Table className="w-100">
                <thead>
                    <tr>
                        <th>Business Unit</th>
                        <th>Message Last Received</th>
                    </tr>
                </thead>
                <tbody>
                    {files && files.map((file, index) =>
                        <tr key={`file-${index}`}>
                            <td>{file.businessUnit}</td>
                            <td><DateAsLocaleString date={file.messageSentAtLocalTime} options={undefined} /></td>
                        </tr>
                    )}
                </tbody>
            </Table>
        )
    }

    return (
        <AdminTile
            title={"Get Most Recent Spec Files"}
            description={"View details about the latest spec file import per business unit"}
            variant={variant}
            onRefresh={getSpecFiles}>
            <SpecFilesTable />
        </AdminTile>
    );
}

export default GetRecentlyReceivedRecipes;